import isEmpty from 'lodash/isEmpty';
import Box from '@mui/material/Box';
import { CircularProgress, P14, P18 } from 'src/components/atoms';
import { StyledFloatingActiveUploads } from 'src/components/EposUpload/FloatingActiveUploads/styled';
import { STATUS_COLOR_MAP } from 'src/components/EposUpload/ActiveUploads/ActiveUploadItem/status-color-map';
import { useListCustomerCentreActiveUploads } from './customer-centre-file-upload-store';
import { FloatingCustomerCentreFileUploadsItem } from './FloatingCustomerCentreFileUploadsItem';

export const FloatingCustomerCentreFileUploads = () => {
  const activeUploads = useListCustomerCentreActiveUploads();
  if (isEmpty(activeUploads) || !Array.isArray(activeUploads)) return null;
  return (
    <StyledFloatingActiveUploads>
      <Box>
        <P18 $fontWeight={500}>Active Uploads &#40;{activeUploads.length}&#41;</P18>
        <P14>Navigating away is allowed except for zone editor.</P14>
      </Box>
      <Box
        sx={{
          ml: 'auto',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <CircularProgress size={18} thickness={6} $color={STATUS_COLOR_MAP.IN_PROGRESS} />
      </Box>

      {activeUploads.map((activeUpload) => (
        <FloatingCustomerCentreFileUploadsItem key={activeUpload.id} activeUpload={activeUpload} />
      ))}
    </StyledFloatingActiveUploads>
  );
};
